module.exports = __webpack_public_path__ + "static/vmware_2.8a9a5e40.png";